import { ConfirmModal, MoreButton } from '@/components';
import { useId } from '@/hooks';
import { useMessage } from '@/providers';
import { type FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useDeleteRole } from '../../hooks';

export const RoleActionsButton: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { id: roleId } = useId();
  const { openMessage } = useMessage();

  const { mutateAsync: deleteRole } = useDeleteRole();

  const [isOpenModal, setIsOpenModal] = useState(false);

  const handleClose = async () => {
    setIsOpenModal(false);
  };

  return (
    <>
      <MoreButton
        items={[
          {
            key: 'delete',
            label: t('delete'),
            danger: true,
          },
        ]}
        onClick={({ key }) => {
          switch (key) {
            case 'delete':
              return setIsOpenModal(true);
          }
        }}
      />
      <ConfirmModal
        open={isOpenModal}
        title={t('delete-confirmation')}
        disclaimerText={t('delete-confirmation-disclaimer')}
        onOk={async () => {
          try {
            await deleteRole(roleId);

            await Promise.all([
              openMessage('success', t('message-delete-completed')),
              (async () => {
                navigate('/tenant-manager?activeKey=roles', {
                  replace: true,
                });
              })(),
            ]);
          } catch {
            await openMessage('error', t('message-delete-failed'));
          }
        }}
        onCancel={handleClose}
      />
    </>
  );
};
